/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef,useState } from "react";
import FormCreator from "../../../components/Forms/FormCreator"
import Buttons from "../../../components/ui/button/Buttons"
import { useDispatch, useSelector } from "react-redux";
import { useLoginMutation } from "../../../app/services/authAPI";
import { authentication } from "../../../app/slice/authSlice";
import LoginFormData from "./LoginForm.data";
import { useNavigate } from "react-router-dom";
import ToastService from "../../../services/toastService/ToastService";
import SwalAlert from "../../../services/swalService/SwalService";
import { createCookie, getCookie, removeCookie } from "../../../utils/Cookies/CookieHandler";


const LoginForm = (props) => {
   const loginFormRef = useRef();
    const { isLogedin, isPasswordResetRequired } = useSelector((state) => state.auth)
   const { success } = SwalAlert()
    const navigate = useNavigate();
    const dispath = useDispatch();
  const [rememberMe, setRememberMe] = useState(false);
  const [loginForm, setLoginForm] = useState(loginFormRef);

  const [isInvalidCredentials, setIsInvalidCredentials] = useState(false);


    const [login,
        { isLoading: loginLoading,
            isSuccess: loginSuccess,
            data: authData }] = useLoginMutation();

    const handleFormDataChange = (formData) => { };

    const handleLogin = () => {
        // Add your authentication logic here
        // If authentication is successful, dispatch a login action
        let authData = loginFormRef.current.getFormData(); // this will help to get form data.
        if (authData) {
            login(authData);
        }
    };

    // Effect to handle a successful authentication
  

    
      useEffect(() => {
    if (loginSuccess && authData) {
      if (authData.isAuthenticated === false) {
        //debugger
        if (authData.twoFactorAuthentication&& authData.message.includes('OTP')) {
          success(authData.message)
            .then((confirmed) => {
              if (confirmed) {
                navigate('/TwoFactorAuthentication', { state: { ...authData, rememberMe } });
              }
            })
        } else if (authData.message.includes('Invalid')) {
          setIsInvalidCredentials(true);
        } else {
          setIsInvalidCredentials(false);
          ToastService.error(authData.message);
        }
      } else if (authData.isAuthenticated === true) {

        dispath(authentication(authData));

        if (rememberMe) {

          const loginForm = loginFormRef.current.getFormData();
          let userLoginDetails = { email: loginForm.psEmailAddress };

          const rememberMeCookie = {
            cookieName: "rememberMe",
            cookieValue: userLoginDetails,
            path: "/",
            expirationTime: 7 * 24,
          }
          createCookie(rememberMeCookie)
        } else {
          removeCookie('rememberMe');
        }
      }
    }
  }, [loginSuccess, authData]);

    // Effect to handle navigation based on the authentication
    useEffect(() => {

        if (isLogedin) {
            if (isPasswordResetRequired) {
                navigate("/ResetPassword")
            }
            else {
                navigate("/Employer")
            }
        }
    }, [isLogedin])

    return (
        <div className="signin-form-part">
            <form>
                <div className="row">
                <FormCreator
                    ref={loginFormRef}
                    {...LoginFormData}
                    onFormDataUpdate={handleFormDataChange}
                ></FormCreator>
                </div>
            </form>
            {/* <a className="forgot-pass-link" href="#change">
                Reset Your Password ?
            </a> */}
            <div className="button-part">
                <Buttons
                    buttonTypeClassName="success-btn"
                    buttonText="Login"
                    onClick={handleLogin}
                    isLoading={loginLoading}
                />
            </div>
        </div>
    )
}
export default LoginForm;